import UniversityForm from "../../components/UniversityForm/UniversityForm";
const EditUniversityBasic = () => {
    return (
        <div style={{ marginTop: '3%' }}>
            <UniversityForm type="Edit" />
        </div>
    )
}
export default EditUniversityBasic;